let moment = require('moment');

const DateFormats = {
    time: "HH:mm",
    date: "DD/MM/YYYY",
    complete: "hh:mm DD/MM/YYYY"
};

module.exports = function (datetime, format) {
    if (moment) {
        return moment(datetime).format(DateFormats[format] ? DateFormats[format] : format);
    } else {
        return datetime;
    }
};


// WEBPACK FOOTER //
// ./src/hbHelpers/formatDate.js